module.exports = __webpack_public_path__ + "img/2025-12-20b_3.ace3614b.jpg";